import { render, staticRenderFns } from "./EducationDetails.vue?vue&type=template&id=1b682547&scoped=true&"
import script from "./EducationDetails.vue?vue&type=script&lang=js&"
export * from "./EducationDetails.vue?vue&type=script&lang=js&"
import style0 from "./EducationDetails.vue?vue&type=style&index=0&id=1b682547&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b682547",
  null
  
)

export default component.exports